// El nombre de la plataforma se LEE, no se escribe.
//
// Ya cambió una vez (Pandemonium -> Pandora) y el nombre viejo sobrevivió en los seis
// idiomas, porque estaba escrito a mano en cada translation.json. Aquí vive el unico sitio
// donde se decide; los textos lo reciben por interpolacion como {{platform}}.
//
// Para fijarlo desde fuera, exportar REACT_APP_PLATFORM_NAME antes del build.
export const PLATFORM_NAME = process.env.REACT_APP_PLATFORM_NAME || 'Pandora';
